import React, { useState } from "react";
import { notifyError, notifySuccess } from "../../../helper";
import client from "../../../api";

const DeleteLabelModelWindow = (props) => {
    const api = client();
    const [loading, setLoading] = useState(false);
    
    const handleDeleteLabel = async () => {
        try{
            setLoading(true);
            const response = await api.post("/v1/label/delete",{
                label_id: props.selectedLabel._id                
            });
            if(response.status === 200 || response.status === 201){
                notifySuccess('Label deleted sucessfully');
                setTimeout(()=>{
                    window.location.reload();
                    props.setToggleDeleteModelWindow(false);

                },1500);
            }
        } catch (error){
            console.log("error.message",error);
            setLoading(false);
            if(error.status === 400){
                notifyError('Bad Request. Unable to update the label. Please try again.');
            }
        } finally{
            setLoading(false);
        }        
    }
    
    return(<>
        <div className="model-window">
        <div className="overlay"></div>
        <div className="model-view">
            <div className="inner-view">
                <h2>Delete Label</h2>
                <p>Are you sure to Delete the Label <span className="high-light">{props.selectedLabel.label_name}</span></p>
                <div className="button-group">
                    <button 
                        type="button" 
                        className={loading ? "delete-btn button--loading":"delete-btn"} 
                        disabled={loading}
                        onClick={()=>handleDeleteLabel()}>
                            <span className="button--text">Delete</span>
                    </button>                        
                    <button className="cancel-btn" onClick={()=>props.setToggleDeleteModelWindow(!props.toggleDeleteModelWindow)}>Cancel</button>
                </div>
            </div>
        </div>
    </div>
    </>);
}
export default DeleteLabelModelWindow;